
//
// Post-Injector
//

PostInjector = function(ruleDefinitions, creationCallbacks) {
	
	this.base = new Injector();
	this.base.initialise(ruleDefinitions.rules, ruleDefinitions.symbolWeights, creationCallbacks);
	
	var _landingData = undefined;
	var _symbols = [];
	var _bounceSymbols = [];
	var _postSymbols = [];
    var	_stateData = {};

	this.saveState = function() {

		// Save state
        _stateData = {};
		var keys = Object.getOwnPropertyNames(this);
		for (var i = 0; i < keys.length; i++) {
			var name = keys[i];
			var type = typeof(this[name]);
			var isCallback = (name.includes("callback") || name.includes("Callback"));
			
			if ((type !== "function") && (name !== "base") && !isCallback) {
				if (checkForDefined(this[name])) {
                    _stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
				}
				else {
                    _stateData[keys[i]] = undefined;
				}
			}
		}

		// Add the local scope variables above
        _stateData._landingData = (checkForDefined(_landingData)) ? JSON.parse(JSON.stringify(_landingData)) : undefined;
        _stateData._symbols = (checkForDefined(_symbols)) ? JSON.parse(JSON.stringify(_symbols)) : undefined;
        _stateData._bounceSymbols = (checkForDefined(_bounceSymbols)) ? JSON.parse(JSON.stringify(_bounceSymbols)) : undefined;
        _stateData._postSymbols = (checkForDefined(_postSymbols)) ? JSON.parse(JSON.stringify(_postSymbols)) : undefined;
        _stateData._stateData = (checkForDefined(_stateData)) ? JSON.parse(JSON.stringify(_stateData)) : undefined;
    };

    this.restoreState = function() {
        var keys = Object.keys(_stateData);
        for (var i = 0; i < keys.length; i++) {
        	var name = keys[i];
        	if (checkForDefined(_stateData[name])) {
                this[name] = JSON.parse(JSON.stringify(_stateData[name]));
			}
			else {
                this[name] = undefined;
			}
		}

        _stateData = {};
    };

    this.initialiseInjector = function(reelId) {
		this.base.reelId = reelId;
		this.base.requiredSymbols = [];
	};
	
	this.setLandingData = function(landingData) {
		//var landingData = {
		//	preappertureSymbols: numberPreSymbols,
		//	aboveLandingSymbols: abovePositions[i],
		//	landingSymbols: positions[i],
		//	belowLandingSymbols: belowPositions[i],
		//	postappertureSymbols: numberPostSymbols,
		//	reverseSpin: spinParams.reverseSpin
		//};
		_landingData = landingData;
	};
	
	this.createLandingSymbols = function(symbolData, requiredSymbols, symbolsLastDrawn) {
		this.base.spinReversed = _landingData.reverseSpin;
		_symbols = [];
		
		this.symbolsLastDrawn = symbolsLastDrawn;
		
		//Copy existing symbol data
		var requiredSymbolsCopy = requiredSymbols.slice();
		var symbolDataUpdated = symbolData.slice();
		
		if (this.base.spinReversed) {
			symbolDataUpdated.reverse();
		}
		
		for (var i = (requiredSymbolsCopy.length - 1); i >= 0; --i) {
			var symbol = requiredSymbolsCopy[i];
			if (typeof(symbol) === 'number') {
				symbol = { symbolId: symbol };
			}
			symbolDataUpdated.unshift(symbol);
		}
		
		this.setLandingSymbols();
		this.createAdditionalSymbols(symbolDataUpdated, requiredSymbolsCopy.length);
		this.finishPreInjectorGroup(requiredSymbolsCopy);
		this.createBounceSymbols();
		
		if (this.base.spinReversed) {
			_symbols.reverse();
		}
	};
	
	this.setLandingSymbols = function() {
		for (var i = 0; i < _landingData.landingSymbols.length; ++i) {
			var symbol = {
				symbolId: _landingData.landingSymbols[i]
			};
			
			if (this.base.spinReversed) {
				_symbols.unshift(symbol);
			}
			else {
				_symbols.push(symbol);
			}
		}
	};
	
	this.createAdditionalSymbols = function(symbolData, requiredSymbolsLength) {
		// Add additional postapperture landing symbols
		if (_landingData.belowLandingSymbols !== undefined) {
			for (var i = 0; i < _landingData.belowLandingSymbols.length; ++i) {
				_symbols.push({
					symbolId: _landingData.belowLandingSymbols[i]
				});
			}
			
			_landingData.postappertureSymbols -= _landingData.belowLandingSymbols.length;
		}
		
		// Add symbols used to finish a landing group
		_landingData.postappertureSymbols -= _postSymbols.length;
		while (_postSymbols.length > 0) {
			var symbol = _postSymbols.pop();
			if (typeof(symbol) === 'number') {
				symbol = { symbolId: symbol };
			}
			_symbols.push(symbol);
		}
		
		this.recalculateSymbolsLastDrawn();
		
		var additionalSymbols = [];
		var requiredPostApperatureSymbols = Math.abs(_landingData.postappertureSymbols - requiredSymbolsLength);
		for (var i = 0; i < requiredPostApperatureSymbols; ++i) {
			var symbol = this.base.getValidSymbol(_symbols, symbolData, (requiredPostApperatureSymbols - i));
            if (typeof(symbol) === 'number') {
                symbol = { symbolId: symbol };
            }
            symbolData.unshift(symbol);
			additionalSymbols.push(symbol);
		}
		
		// Copy additional symbols
		while (additionalSymbols.length > 0) {
			_symbols.push(additionalSymbols.pop());
		};
	};
	
	this.finishPreInjectorGroup = function(requiredSymbols) {
		while (requiredSymbols.length > 0) {
			var symbol = requiredSymbols.pop();
			if (typeof(symbol) === 'number') {
				symbol = { symbolId: symbol };
			}
			_symbols.push(symbol);
		};
	};
	
	this.createBounceSymbols = function() {
		this.requiredSymbols = _bounceSymbols.slice();
		_bounceSymbols = [];
		
		// Add additional preapperture landing symbols
		if (_landingData.aboveLandingSymbols !== undefined) {
			for (var i = (_landingData.aboveLandingSymbols.length - 1); i >= 0; --i) {
				_symbols.unshift({
					symbolId: _landingData.aboveLandingSymbols[i]
				});
			}
			
			_landingData.preappertureSymbols -= _landingData.aboveLandingSymbols.length;
		}
		
		this.recalculateSymbolsLastDrawn();
		
		for (var i = 0; i < _landingData.preappertureSymbols; ++i) {
			var symbol = this.base.getValidSymbol([], _symbols, -1);
            if (typeof(symbol) === 'number') {
                symbol = { symbolId: symbol };
            }
			_symbols.unshift(symbol);
		}
	};
	
	this.getNextSymbol = function(symbolData) {		
		if (this.base.spinReversed) {
			return _symbols.shift();
		}
		
		return _symbols.pop();
	};

    this.getSymbolChildData = function(symbolId) {
        return this.base.getSymbolChildData(symbolId);
    }
	
	this.recalculateSymbolsLastDrawn = function() {
		var keys = Object.keys(this.symbolsLastDrawn);
		for (var i = 0; i < keys.length; ++i) {
			var index = _symbols.findIndex(function(element) {
				return (element.symbolId == keys[i]);
			});
			
			if (index < 0) {
				this.symbolsLastDrawn[keys[i]] = 999;
			}
		}
	};
	
	Object.defineProperty(this, "remainingSymbols", 
	{
		get: function() {
			return _symbols.length;
		}
	});
	
	Object.defineProperty(this, "symbolsLastDrawn", 
	{
		get: function() {
			return this.base.symbolsLastDrawn;
		},
		set: function(symbols) {
			var keys = Object.keys(symbols);
			for (var i = 0; i < keys.length; ++i) {
				this.base.symbolsLastDrawn[keys[i]] = symbols[keys[i]];
			}
		}
	});
	
	Object.defineProperty(this, "requiredSymbols", 
	{
		get: function() {
			return this.base.requiredSymbols;
		},
		set: function(symbols) {
			this.base.requiredSymbols = symbols;
		}
	});
	
	Object.defineProperty(this, "bounceSymbols",
	{
		get: function() {
			return _bounceSymbols;
		},
		set: function(symbols) {
			_bounceSymbols = symbols;
		}
	});
	Object.defineProperty(this, "postSymbols",
	{
		get: function() {
			return _postSymbols;
		},
		set: function(symbols) {
			_postSymbols = symbols;
		}
	});
	Object.defineProperty(this, "hasLandingSymbols",
	{
		get: function() {
			return ((_landingData !== undefined) && (_landingData.landingSymbols !== undefined));
		}
	});
};